import React, { useEffect, useState } from "react";

const latestLog = (logs, statuses) =>
  (logs || [])
    .filter((log) => statuses.includes(log.status))
    .reduce(
      (latest, log) =>
        !latest || new Date(log.createdAt) > new Date(latest.createdAt) ? log : latest,
      null
    );

// Preparation time = latest "Preparing" -> "Ready for Dispatch" (or dispatch when
// the booking was dispatched straight away). end is null while still preparing.
export const getPrepareTimeRange = (item) => {
  const prepareLog = latestLog(item.bookingLogs, ["prepare", "prepare dispatch"]);
  if (!prepareLog) return null;

  const start = new Date(prepareLog.createdAt);
  const readyLog = latestLog(item.bookingLogs, ["ready_for_dispatch"]);

  if (readyLog && new Date(readyLog.createdAt) >= start) {
    return { start, end: new Date(readyLog.createdAt) };
  }
  // Amended after dispatch: old prepare time stays stopped at the old dispatch time
  const amendLog = latestLog(item.bookingLogs, ["amended after dispatch"]);
  if (amendLog && new Date(amendLog.createdAt) >= start) {
    return { start, end: new Date(amendLog.prepare_end_at || amendLog.createdAt) };
  }
  if (item.status === "dispatch") {
    const dispatchTime = item.dispatchDate || item.bookingdispatches?.[0]?.createdAt;
    if (dispatchTime) return { start, end: new Date(dispatchTime) };
  }
  return { start, end: null };
};

const PrepareTimer = ({ item }) => {
  const [time, setTime] = useState("-");

  useEffect(() => {
    const range = getPrepareTimeRange(item);

    if (!range) {
      setTime("-");
      return;
    }

    // Stopped at ready for dispatch / dispatch
    if (range.end) {
      setTime(calcDiff(range.start, range.end));
      return;
    }

    const interval = setInterval(() => {
      setTime(calcDiff(range.start, new Date()));
    }, 1000);

    setTime(calcDiff(range.start, new Date()));

    return () => clearInterval(interval);
  }, [item.status, item.bookingLogs, item.bookingdispatches]);

  return <span>{time}</span>;
};

const pad = (num) => String(num).padStart(2, "0");

// helper
export const calcDiff = (start, end) => {
    const diffMs = end - start;
    if (diffMs <= 0) return "00h 00m 00s";

    const totalSeconds = Math.floor(diffMs / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export default PrepareTimer; // ✅ IMPORTANT
